<h6 mat-dialog-title>Select endpoint</h6>

<div mat-dialog-content>
  <eva-endpoint-selector></eva-endpoint-selector>
</div>
